module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/alizee.2edda56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/alizee.jpg
// module id = Zt38
// module chunks = 0